import { render, staticRenderFns } from "./ProviderBillingCard.vue?vue&type=template&id=498d3928&scoped=true&"
import script from "./ProviderBillingCard.vue?vue&type=script&lang=js&"
export * from "./ProviderBillingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d3928",
  null
  
)

export default component.exports